import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Storage } from '@ionic/storage';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Http, HttpOptions } from '@capacitor-community/http';
import { from, Observable, Subscription } from 'rxjs';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import * as QRCode from 'qrcode';
import { ToastController } from '@ionic/angular';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { AesRandomizerService } from 'src/app/randomizer_service/aes-randomizer.service';
import { GetDataType, PostDataType } from './service.types';
import { finalize } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
// import { Mod0475Page } from 'src/app/reports/mod0475/mod0475.page';
import * as ExcelJS from 'exceljs';

type GenericJSONobj = {
  [key: string]: any;
};
@Injectable({
  providedIn: 'root',
})

export class ServiceService {
  private companyUpdateSubject = new BehaviorSubject<any>(null);
  companyUpdated$ = this.companyUpdateSubject.asObservable();

  announceCompanyUpdate(company: any) {
    this.companyUpdateSubject.next(company);
  }

  private sharedDataSubject = new BehaviorSubject<any>(null);
  sharedData$ = this.sharedDataSubject.asObservable();

  setSharedData(value: any) {
    this.sharedDataSubject.next(value);
  }
  app_pin_key: string = 'PSTpin';
  admin_usertype: string = '1';
  BranchHead_usertype: string = '6';
  cpt_session_keys = {
    mod0101: '',
    mod0102: '',
    mod0123: '',
    mod0129: '',
    mod0132: '',
    mod0133: '',
    mod0184: '',
    mod0503: '',
  };
  cpt_views = {
    mod0129: {
      'session-for': 'captcha-course_reg-user',
      'cptid-keyname': 'creg-user-cptid',
    },
    mod0101: {
      'session-for': 'captcha-login',
      'cptid-keyname': 'cptid',
    },
    mod0102: {
      'session-for': 'captcha-register',
      'cptid-keyname': 'reg-cptid',
    },
    mod0123: {
      'session-for': 'captcha-mobno_validate',
      'cptid-keyname': 'mobno-cptid',
    },
    mod0132: {
      'session-for': 'captcha-course_reg_old',
      'cptid-keyname': 'creg_old-cptid',
    },
    mod0133: {
      'session-for': 'captcha-course_reg-open',
      'cptid-keyname': 'creg-cptid',
    },
    mod0184: {
      'session-for': 'captcha-user-kyc',
      'cptid-keyname': 'kyc-user-cptid',
    },
    mod0503: {
      'session-for': 'captcha-user-kyc',
      'cptid-keyname': 'kyc-user-cptid',
    },
  };

  lat: any;
  lon: any;

  result = {
    action: '1',
    response: {},
  };
  response = {};
  action = '1';

  saved_nav_stack = [];
  privilage_array: string[] = [];

  isLoading = false;
  AppLoader: HTMLIonLoadingElement;

  private sharedData: any;

  nav_stack = [];
  backButtonSubscription: Subscription;

  alert_exist: boolean = false;
  billary: any = {};
  show_spinner: boolean = false;
  hide_refresh_button: boolean = false;
  MAX_FILESIZE_COMMON: number = 400 * 1024; // 400 kilobytes

  DefaultModuleName: any;
  toastData: any = null;

  isRouteLoading: boolean = false;
  private activeApiRequests = 0;

  get isGlobalLoading(): boolean {
    return this.show_spinner || this.isRouteLoading;
  }

  updateApiLoading(isLoading: boolean) {
    if (isLoading) {
      this.activeApiRequests++;
    } else {
      this.activeApiRequests = Math.max(0, this.activeApiRequests - 1);
    }
    this.show_spinner = this.activeApiRequests > 0;
  }
  constructor(
    private http: HttpClient,
    public loadingController: LoadingController,
    public alertController: AlertController,
    private storage: Storage,
    public platform: Platform,
    private router: Router,
    private cookies: CookieService,
    private toastController: ToastController,
    private ardService: AesRandomizerService
  ) {
    console.log('test cpt id on service init :');
    for (const [key, value] of Object.entries(this.cpt_views)) {
      console.log(
        `
        view_name = ${key}; 
        key_name = ${value['cptid-keyname']}; 
        key_value = ${this.localStorage.getItem(value['cptid-keyname'])}
        `
      );
    }
  }

  platform_back_button_function(url: String) {
    var back_url: String = '/master';

    if (url == 'mod0129') {
      back_url = '/master';
    } else if (url == 'mod0119') {
      back_url = '/master';
    } else if (url.includes('mod0137')) {
      back_url = '/exam/mod0129';
    } else if (url.includes('mod0134')) {
      back_url = 'exam/mod0129';
    } else if (url == 'mod0103') {
      back_url = '/master';
    } else if (url == 'mod0312') {
      back_url = '/master';
    } else {
      back_url = '/master';
    }

    return back_url;
  }

  SplitUrl(url: String) {
    if (this.DefaultModuleName?.length) {
      return this.DefaultModuleName;
    } else {
      var parts = url.split('/');
      var lastPart = parts[parts.length - 1].split(';')[0];
      return lastPart;
    }
  }


  getSharedData() {
    return this.sharedData;
  }

  // jinoth Qr entry
  //position:'top' | 'middle' | 'bottom'
  async presenttoast(
    msg: any,
    position: 'top' | 'middle' | 'bottom' = 'middle'
  ) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      position: position,
    });

    await toast.present();
  }

  getLocation() {
    if (navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition((pos) =>
        this.showPosition(pos)
      );
    }
  }

  showPosition(position: any) {
    this.lat = position.coords.latitude;
    this.lon = position.coords.longitude;
  }

  generateQRCode(data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(data, (err, url) => {
        if (err) {
          reject(err);
        } else {
          resolve(url);
        }
      });
    });
  }

  IsValidMobileNumber(mobileNumber) {
    if (!mobileNumber) {
      return false;
    }

    // Remove any non-digit characters
    const cleanedNumber = String(mobileNumber).replace(/\D/g, '');

    // Check if the cleaned number has exactly 10 digits
    if (!/^\d{10}$/.test(cleanedNumber)) {
      return false;
    }

    // Disallow all same digits (e.g. 0000000000, 1111111111, 2222222222 ... 9999999999)
    if (/^(\d)\1{9}$/.test(cleanedNumber)) {
      return false;
    }

    // Disallow sequential numbers (e.g. 1234567890, 0987654321, 0123456789, 9876543210)
    let isAsc = true;
    let isDesc = true;
    for (let i = 0; i < cleanedNumber.length - 1; i++) {
      let curr = parseInt(cleanedNumber[i], 10);
      let next = parseInt(cleanedNumber[i + 1], 10);
      if ((curr + 1) % 10 !== next) isAsc = false;
      if ((curr - 1 + 10) % 10 !== next) isDesc = false;
    }
    if (isAsc || isDesc) {
      return false;
    }

    return true;
  }

  // call_api_post_ajax(
  //   url: string,
  //   data: { [key: string]: any },
  //   modname: string = '',
  //   callback: Function = () => {}
  // ): void {
  //   $.ajax({
  //     url: url,
  //     method: 'POST',
  //     headers: {
  //       Authorization: this.get_session_id_login(),
  //       'Content-Type': 'application/json',
  //       // modname: modname,
  //     },
  //     data: JSON.stringify({ ...data, modname }),
  //     success: function (response) {
  //       callback(response);
  //     },
  //     error: function (xhr, status, error) {
  //       console.log('Error:', error);
  //     },
  //   });
  // }

  call_api_post(
    url: string,
    data: { [key: string]: any } | FormData,
    modname: string = '',
    isFormData: boolean = false
  ): Observable<any> {
    if (isFormData) data.append('modname', modname);
    else data = { ...data, modname };
    const headers = {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      Authorization: this.get_session_id_login(),
    };
    return this.http.post(url, data, { headers });
  }

  appendParamsToGetUrl(
    url: string,
    data: { [key: string]: string | number | null }
  ): string {
    let urlobj = new URL(url);
    for (let key in data) {
      if (key == 'modname' && urlobj.searchParams.get(key)) {
        // skip changing modname
        continue;
      }
      if (data[key] != null) urlobj.searchParams.set(key, String(data[key]));
    }
    return urlobj.href;
  }

  defaultErrHandler(err: any) {
    const {
      error: errData,
      headers,
      message,
      name,
      status,
      statusText,
      url,
    } = err;
    console.log(err);

    let errText = 'An error occurred';

    if (status == 403) {
      errText = errData?.detail || 'Invalid Session Key';
      if (errText == 'Session Expired') {
        // TODO: debug for android
        if (Capacitor.getPlatform() === 'android') {
          // goto pinlogin page only for android app
          this.alert.warningAlert({
            text: 'Your Session Has Expired, Please Login',
            action: 'warning',
            callback: () => {
              window.location.replace('/pinlogin');
            },
          });
        } else {
          // alert and redirect to login after properly clearing localstorage data of user
          this.alert.warningAlert({
            text: 'Your Session Has Expired, Please Login',
            action: 'warning',
            callback: () => {
              this.logout();
            },
          });
        }
      } else {
        this.alert.warningAlert({
          text: errText,
          action: 'error',
          callback: () => {
            this.logout();
          },
        });
      }
    } else if (status == 0) {
      errText = 'Network Error';
      this.alert.warningAlert({
        text: errText,
        action: 'error',
        callback: () => {
          // TODO: hide loader if needed
          if (this.show_spinner) this.updateApiLoading(false);
        },
      });
    } else {
      this.common_errorCb(err);
    }
  }

  common_errorCb = (err, errTxt = '') => {
    console.log(err);
    this.alert.warningAlert({
      text: errTxt || 'An error occurred',
      action: 'error',
      callback: () => {
        // TODO: hide loader if needed
        if (this.show_spinner) this.updateApiLoading(false);
      },
    });
  };

  defaultCompleteHandler = () => {
    // console.log('http post completed');
  };

  call_http_get(getObj: GetDataType): Subscription {
    const {
      url,
      modname = '',
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: GetDataType = getObj;

    const headers = {
      Authorization: this.get_session_id_login(),
    };

    let errorHandlerCb = (error) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = (err) => {
        this.defaultErrHandler(err);
      };
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error);
        afterError(error);
      };
    }

    return this.http
      .get(this.appendParamsToGetUrl(url, { modname }), {
        headers,
      })
      .pipe(
        finalize(completeCb)
        // called on both sucess and error
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
    // .subscribe({
    //   next: successCb, error: errorHandlerCb,
    //   complete: () => {
    //     // called after success/next only, not called after error
    //   },
    // })
  }

  call_http_post(
    postObj: PostDataType,
    control_spinner_locally: boolean = false
  ): Subscription {
    const {
      url,
      modname = '',
      allowpage = false,
      isFormData = false,
      responseType,
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: PostDataType = postObj;

    let data = postObj.data;
    if (!data) {
      if (isFormData) data = new FormData();
      else data = {};
    }

    if (isFormData) {
      if (!data.get('modname')) data.append('modname', modname);
      if (!data.get('allowpage')) data.append('allowpage', allowpage);
    } else {
      if (!data['modname']) data = { ...data, modname, allowpage };
    }

    const headers = {
      Authorization: this.get_session_id_login(),
    };

    if (!isFormData) headers['Content-Type'] = 'application/json';

    const requestOptions = {
      headers,
    };

    if (responseType) requestOptions['responseType'] = responseType;

    let errorHandlerCb = (error) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = (err) => {
        this.defaultErrHandler(err);
      };
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error);
        afterError(error);
      };
    }

    // // using Http.request doesnt get intercepted by HttpInterceptor
    // const options: HttpOptions = { url, method: 'POST', headers, data };
    // return from(Http.request(options));

    if (!control_spinner_locally) this.updateApiLoading(true);

    return this.http
      .post(url, data, requestOptions)
      .pipe(
        finalize(() => {
          if (!control_spinner_locally) this.updateApiLoading(false);
          completeCb();
        })
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
  }


  call_http_post_no_loader(
    postObj: PostDataType,
    control_spinner_locally: boolean = false
  ): Subscription {
    const {
      url,
      modname = '',
      allowpage = false,
      isFormData = false,
      responseType,
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: PostDataType = postObj;

    let data = postObj.data;
    if (!data) {
      if (isFormData) data = new FormData();
      else data = {};
    }

    if (isFormData) {
      if (!data.get('modname')) data.append('modname', modname);
      if (!data.get('allowpage')) data.append('allowpage', allowpage);
    } else {
      if (!data['modname']) data = { ...data, modname, allowpage };
    }

    const headers = {
      Authorization: this.get_session_id_login(),
    };

    if (!isFormData) headers['Content-Type'] = 'application/json';

    const requestOptions = {
      headers,
    };

    if (responseType) requestOptions['responseType'] = responseType;

    let errorHandlerCb = (error) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = (err) => {
        this.defaultErrHandler(err);
      };
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error);
        afterError(error);
      };
    }

    // // using Http.request doesnt get intercepted by HttpInterceptor
    // const options: HttpOptions = { url, method: 'POST', headers, data };
    // return from(Http.request(options));

    // if (!control_spinner_locally) this.updateApiLoading(true);

    return this.http
      .post(url, data, requestOptions)
      .pipe(
        finalize(() => {
          if (!control_spinner_locally) this.updateApiLoading(false);
          completeCb();
        })
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
  }


  call_http_request(
    postObj: PostDataType,
    control_spinner_locally: boolean = false
  ): Subscription {
    const {
      url,
      modname = '',
      allowpage = false,
      method = 'POST',
      isFormData = false,
      responseType,
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: PostDataType = postObj;

    let data: FormData | GenericJSONobj | undefined = postObj.data;
    if (!data) {
      if (isFormData) data = new FormData();
      else data = {};
    }

    if (isFormData) {
      if (!data.get('modname')) data.append('modname', modname);
      if (!data.get('allowpage')) data.append('allowpage', allowpage);
    } else {
      if (!data['modname']) data = { ...data, modname, allowpage };
    }

    const headers: GenericJSONobj = {
      Authorization: this.get_session_id_login(),
    };

    if (method !== 'GET' && !isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const requestOptions: GenericJSONobj = {
      headers,
    };

    if (responseType) requestOptions['responseType'] = responseType;

    let errorHandlerCb = (error: any) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = (err) => {
        this.defaultErrHandler(err);
      };
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error);
        afterError(error);
      };
    }

    // // using Http.request doesnt get intercepted by HttpInterceptor
    // const options: HttpOptions = { url, method: 'POST', headers, data };
    // return from(Http.request(options));

    if (!control_spinner_locally) this.updateApiLoading(true);

    let httpCall;
    switch (method.toUpperCase()) {
      case 'GET':
        const paramsData = {
          ...(data as any),
          modname,
          allowpage,
        };

        httpCall = this.http.get(
          this.appendParamsToGetUrl(url, paramsData),
          { headers }
        );
        break;
      case 'POST':
        httpCall = this.http.post(url, data, requestOptions);
        break;
      case 'PUT':
        httpCall = this.http.put(url, data, requestOptions);
        break;
      case 'DELETE':
        httpCall = this.http.delete(url, { ...requestOptions, body: data });
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
    // console.log(httpCall, method, 'call');

    return httpCall
      .pipe(
        finalize(() => {
          if (!control_spinner_locally) this.updateApiLoading(false);
          completeCb();
        })
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
  }

  private getLSItem = (key: string) => {
    return this.ardService.removeRandomizer(
      localStorage.getItem(this.ardService.applyRandomizer(key)) ||
      AesRandomizerService.emptyStr
    );
    // default value : null
  };

  private setLSItem = (key: string, value: string) => {
    if (value == null || value == undefined) value = '';
    localStorage.setItem(
      this.ardService.applyRandomizer(key),
      this.ardService.applyRandomizer(value)
    );
  };

  private removeLSItem = (key: string) => {
    localStorage.removeItem(this.ardService.applyRandomizer(key));
  };

  localStorage = {
    getItem: this.getLSItem,
    setItem: this.setLSItem,
    removeItem: this.removeLSItem,
  };

  get_session_id_login() {
    // if (this.platform.is('cordova')) return "";
    return this.localStorage.getItem('token');
  }

  get_user_details_in_cookies() {
    return this.localStorage.getItem('user_name');
  }

  // For alert
  async presentAlert(input_msg: any, callback: Function = () => { }) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      // header: 'Message',
      message: input_msg,
      buttons: ['OK'],
    });
    await alert.present();
    // const { role } = await alert.onDidDismiss()
    // console.log('onDidDismiss resolved with role', role);
    alert.onDidDismiss().then(() => callback());
  }

  // async presentAlertConfirm() {
  //   const alert = await this.alertController.create({
  //     cssClass: 'my-custom-class',
  //     header: 'User not Found',
  //     message: 'Are you want to register?',
  //     buttons: [
  //       {
  //         text: 'Try again',
  //         role: 'cancel',
  //         cssClass: 'secondary',
  //         id: 'cancel-button',
  //         handler: (blah) => {
  //           console.log('Confirm Cancel: blah');
  //         }
  //       }, {
  //         text: 'Register',
  //         id: 'confirm-button',
  //         handler: () => {
  //           this.router.navigate(['/mod0123'])
  //         }
  //       }
  //     ]
  //   });

  //   await alert.present();
  // }

  call_api_post_JSON(url: any, data: any, callback: any) {
    $.ajax({
      url: url,
      method: 'POST',
      headers: {
        Authorization: this.get_session_id_login(),
      },
      data: JSON.stringify(data),
      success: function (response) {
        callback(response);
      },
      error: function (xhr, status, error) {
        console.log('Error:', error);
      },
    });
  }

  async confirmProceedToRegister() {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      this.alert.newConfirmationAlert({
        title: 'User Not Found',
        text: 'Do You Want to Register ?',
        confirmCallback: () => {
          // this.updateApiLoading(false);
          this.alert_exist = false;
          this.router.navigate(['/master/mod0123']);
        },
        cancelCallback: () => {
          this.newWarningAlert({
            title: 'User Not Found',
            text: 'Try again',
            action: 'warning',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  async presentConfirm(opts: any = {}) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: opts.header || '',
      message: opts.text || 'Kindly confirm this to proceed',
      buttons: [
        {
          text: opts.okBtnText || 'OK',
          id: 'confirm-button',
          handler: opts.okbtnHandler,
        },
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: opts.cancelHandler,
        },
      ],
    });

    await alert.present();
  }

  presentModalLoader(
    props: {
      text?: string;
      showForMs?: number;
      onPresent?: () => void;
    } = {}
  ) {
    if (!this.isLoading) {
      console.log('loader called');
      let { text: message, showForMs: duration, onPresent = () => { } } = props;
      // console.log({ message, duration });
      this.isLoading = true;
      this.loadingController
        .create({
          message,
          duration,
          // animated: true, backdropDismiss: false,
        })
        .then((a) => {
          this.AppLoader = a;
          a.present().then(() => {
            console.log('loader presented');
            onPresent();
          });
        });
    }
  }

  dismissModalLoader(onDismiss?: () => void) {
    console.log('loader dismiss called');
    if (this.isLoading) {
      if (!onDismiss) onDismiss = () => { };
      this.isLoading = false;
      if (this.AppLoader) {
        setTimeout(() => {
          this.AppLoader.dismiss().then(() => {
            onDismiss();
            console.log('loader dismiss done');
            this.AppLoader = null;
          });
        }, 500);
      }
    }
  }

  scroll_event(selector: string) {
    document.querySelector(selector).scrollIntoView({
      behavior: 'smooth',
      block: 'center', // 'true
      inline: 'center', // 'nearest'
    });
  }
  scroll_event_top(selector: string) {
    document.querySelector(selector).scrollIntoView({
      behavior: 'smooth',
      block: 'start', // 'true
      inline: 'center', // 'nearest'
    });
  }

  scroll_to_element(element: HTMLElement) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center', // 'true
      inline: 'center', // 'nearest'
    });
  }

  scroll_to_top() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  onContentScroll(event) {
    // Handle the scroll event here
    // You can access event.detail.scrollTop to get the current scroll position
    const scrollTop = event.detail.scrollTop;
    console.log('Scroll position:', scrollTop);

    // You can add your custom logic based on the scroll position
    if (scrollTop > 100) {
      // Do something when scrolled beyond a certain point
    }
  }

  async confirmExitApp() {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      this.alert.newConfirmationAlert({
        title: 'Confirmation',
        text: 'Are You Sure Want To Exit The App?',
        action: 'warning',
        confirmBtnText: 'Yes, proceed',
        cancelBtnText: 'No, cancel',
        confirmCallback: () => {
          this.alert_exist = false;
          App.exitApp();
        },
        cancelCallback: () => {
          this.alert_exist = false;
        },
      });
    }
  }

  logout() {
    this.call_http_post({
      url: environment.API_URL + 'mastermodule/logout',
      data: {
        user_id: this.localStorage.getItem('user_id'),
        login_dt: this.localStorage.getItem('login_dt'),
        sid: this.get_session_id_login(),
      },
      successCb: (res) => {
        var result = res.data;
        // console.log({ result });
        // let { message } = result;
        // if message == "ok"
        this.clearUserSession();
        window.location.replace('/mod0101');
      },
    });
  }

  clearUserSession() {
    // Clear App PIN
    this.localStorage.removeItem(this.app_pin_key);

    this.localStorage.removeItem('token');

    this.localStorage.removeItem('user_id');
    this.localStorage.removeItem('user_type');

    this.localStorage.removeItem('user_name');
    this.localStorage.removeItem('designation');
    this.localStorage.removeItem('isAdmin');
    this.localStorage.removeItem('mobile');
    this.localStorage.removeItem('user_branch');
    this.localStorage.removeItem('user_region');
    this.localStorage.removeItem('user_staff_id');
    this.localStorage.removeItem('user_region_id');
    this.localStorage.removeItem('user_branch_id');

    this.cookies.delete('session_key');
  }

  //ROWS SHOWING FUNCTION
  showig_rows_count(maxRows, pageNum, totalRows) {
    //Default rows showing
    var end_index = maxRows * pageNum;
    var start_index = maxRows * pageNum - maxRows + 1;
    var string =
      'Showing ' +
      start_index +
      ' to ' +
      end_index +
      ' of ' +
      totalRows +
      ' entries';
    $('.rows_count').html(string);
  }

  getDT(dt) {
    let dtObj = new Date(dt);
    return dtObj.toLocaleDateString() + ' ' + dtObj.toLocaleTimeString();
  }
  getMonthName(m) {
    var month_names = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return month_names[m];
  }
  getMonthNameShort(m) {
    var month_names_short = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return month_names_short[m];
  }

  getDTperFormat(dt, format = 'dd/MM/yyyy hh:mm ap') {
    let dtObj = new Date(dt);
    format = format.replace(
      'yyyy',
      String(dtObj.getFullYear()).padStart(4, '0')
    );
    format = format.replace('MMMM', this.getMonthName(dtObj.getMonth()));
    format = format.replace('MMM', this.getMonthNameShort(dtObj.getMonth()));
    format = format.replace(
      'MM',
      String(dtObj.getMonth() + 1).padStart(2, '0')
    );
    format = format.replace('dd', String(dtObj.getDate()).padStart(2, '0'));
    format = format.replace('HH', String(dtObj.getHours()).padStart(2, '0'));
    format = format.replace('mm', String(dtObj.getMinutes()).padStart(2, '0'));
    let hr = dtObj.getHours();
    let hh = hr % 12;
    let apm = 'AM';
    if (hr >= 12) {
      apm = 'PM';
      if (hr == 12) hh = 12;
    }
    format = format.replace('hh', String(hh).padStart(2, '0'));
    format = format.replace('ss', String(dtObj.getSeconds()).padStart(2, '0'));
    format = format.replace('ap', apm);
    return format;
  }

  getUTCdateStr(dt) {
    let dtObj = new Date(dt);
    return (
      dtObj.getUTCFullYear() +
      '-' +
      String(dtObj.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(dtObj.getUTCDate()).padStart(2, '0') +
      ' ' +
      String(dtObj.getUTCHours()).padStart(2, '0') +
      ':' +
      String(dtObj.getUTCMinutes()).padStart(2, '0') +
      ':00'
    );
  }

  // should be done in backend
  validateAdmin() {
    return this.localStorage.getItem('isAdmin') == 'true';
    /*
    this.call_api_post("", {
      session_key: this.get_session_id_login()
    }).subscribe((res:any) => {
      var result = res.data
      return result['isAdmin'] == 1;
    })
    */
  }

  validateBranchHead() {
    return this.localStorage.getItem('isBranchHead') == 'true';
  }

  intToEnglish(number) {
    var NS = [
      { value: 10000000, str: 'Crore' },
      { value: 100000, str: 'Lakh' },
      { value: 1000, str: 'Thousand' },
      { value: 100, str: 'Hundred' },
      { value: 90, str: 'Ninety' },
      { value: 80, str: 'Eighty' },
      { value: 70, str: 'Seventy' },
      { value: 60, str: 'Sixty' },
      { value: 50, str: 'Fifty' },
      { value: 40, str: 'Forty' },
      { value: 30, str: 'Thirty' },
      { value: 20, str: 'Twenty' },
      { value: 19, str: 'Nineteen' },
      { value: 18, str: 'Eighteen' },
      { value: 17, str: 'Seventeen' },
      { value: 16, str: 'Sixteen' },
      { value: 15, str: 'Fifteen' },
      { value: 14, str: 'Fourteen' },
      { value: 13, str: 'Thirteen' },
      { value: 12, str: 'Twelve' },
      { value: 11, str: 'Eleven' },
      { value: 10, str: 'Ten' },
      { value: 9, str: 'Nine' },
      { value: 8, str: 'Eight' },
      { value: 7, str: 'Seven' },
      { value: 6, str: 'Six' },
      { value: 5, str: 'Five' },
      { value: 4, str: 'Four' },
      { value: 3, str: 'Three' },
      { value: 2, str: 'Two' },
      { value: 1, str: 'One' },
    ];

    var result = '';
    for (var n of NS) {
      if (number >= n.value) {
        if (number <= 99) {
          result += n.str;
          number -= n.value;
          if (number > 0) result += ' ';
        } else {
          var t = Math.floor(number / n.value);
          // console.log(t);
          var d = number % n.value;
          if (d > 0) {
            return (
              this.intToEnglish(t) + ' ' + n.str + ' ' + this.intToEnglish(d)
            );
          } else {
            return this.intToEnglish(t) + ' ' + n.str;
          }
        }
      }
    }
    return result;
  }

  // To Convert Table in to PDF

  // async generatePDF(table_card_1,table_id,table_heading ='REPORT',table_name='REPORT',font_size=8) {
  //   if(this.alert_exist==false)
  //   {
  //     this.alert_exist=true
  //     const alert = await this.alertController.create({
  //       header: 'Confirmation',
  //       message: 'Are You Sure Want To Download The PDF ?',
  //       buttons: [
  //         {
  //           text: 'Cancel',
  //           role: 'cancel',
  //           cssClass: 'secondary',
  //           handler: () => {
  //             return
  //           }
  //         }, {
  //           text: 'OK',
  //           handler: () => {

  //             this.Confirm_generatePDF(table_card_1,table_id,table_heading ='REPORT',table_name='REPORT',font_size=8)

  //           }
  //         }
  //       ]
  //     });

  //     await alert.present();
  //     this.alert_exist=false
  //   }
  // }

  async generatePDF(
    table_card_1,
    table_id,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    if (this.alert_exist == false) {
      this.alert_exist = true;


      this.newConfirmationAlert({
        text: 'Are You Sure Want To Download The PDF ?',
        confirmCallback: () => {
          this.Confirm_generatePDF(
            table_card_1,
            table_id,
            table_heading,
            table_name,
            font_size,
          );
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.newWarningAlert({
            text: 'cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_generatePDF(
    table_card_1: string,
    table_id: string,
    table_heading = 'Report',
    table_name = 'REPORT',
    font_size = 8
  ) {
    const tableElement = document.getElementById(table_id);
    const columnCount = tableElement?.querySelectorAll('thead th').length || 0;
    const doc = new jsPDF('p', 'mm', 'a4');

    const logoURL = '/assets/icon/logo_opaq.png';
    const IsologoURL = '/assets/icon/postulateisonew.png';

    /* ---------------- HEADER ---------------- */
    const addHeader = () => {
      // Left logo
      doc.addImage(logoURL, 'PNG', 10, 8, 40, 15);

      // Right logo
      const imgWidth = 20;
      const imgHeight = 10;
      const marginRight = 10;
      const pageWidth = doc.internal.pageSize.getWidth();
      const xPosition = pageWidth - imgWidth - marginRight;

      doc.addImage(IsologoURL, 'PNG', xPosition, 8, imgWidth, imgHeight);
    };

    /* ---------------- FOOTER ---------------- */
    const leftFooterContent = '+91 9489715036';
    const rightFooterContent = 'postulate.in';

    const CurentDate = new Date().toISOString().substring(0, 10);
    const CurrentTime = new Date().toLocaleTimeString('en-US', {
      hour12: true,
    });
    const user_mobile = this.localStorage.getItem('mobile') || '';

    const addFooter = () => {
      doc.setFontSize(9);
      doc.text(leftFooterContent, 10, doc.internal.pageSize.height - 10);
      doc.text(
        rightFooterContent,
        doc.internal.pageSize.width - 30,
        doc.internal.pageSize.height - 10
      );
    };

    /* ---------------- INIT ---------------- */
    addHeader();

    /* ---------------- TITLE ---------------- */
    doc.setFontSize(16);
    doc.setTextColor(0);

    const textWidth =
      (doc.getStringUnitWidth(table_heading) *
        (doc as any).internal.getFontSize()) /
      doc.internal.scaleFactor;

    doc.text(table_heading, (doc.internal.pageSize.width - textWidth) / 2, 30);

    /* ---------------- HEADER CARD ---------------- */
    const cardElement = document.getElementById(table_card_1);

    if (cardElement) {
      // Remove empty cells to reduce height
      cardElement.querySelectorAll('td').forEach((td) => {
        if (!td.innerText.trim()) {
          td.style.display = 'none';
        }
      });

      (doc as any).autoTable({
        html: cardElement,
        startY: 38,
        theme: 'plain',
        styles: {
          fontSize: 8,
          fontStyle: 'bold',
          valign: 'middle',
          cellPadding: { top: 2, right: 4, bottom: 2, left: 4 },
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 60 },
          2: { cellWidth: 60 },
        },
        didDrawPage: () => {
          addHeader();
          addFooter();
        },
      });

      /* ---------------- HEADER END POSITION ---------------- */
      const headerEndY = (doc as any).lastAutoTable?.finalY || 38;
      /* ---------------- MAIN TABLE ---------------- */
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginLeft = 2;
      const marginRight = 2;
      const usableWidth = pageWidth - marginLeft - marginRight;

      (doc as any).autoTable({
        html: '#' + table_id,
        startY: headerEndY + 6,
        pageBreak: 'auto',
        rowPageBreak: 'auto',

        styles: {
          fontSize: columnCount > 14 ? 5 : columnCount > 10 ? 7 : font_size,
          cellPadding: 2,
          valign: 'middle',
          halign: 'center',
          overflow: 'linebreak'
        },

        headStyles: {
          fillColor: [108, 11, 169],
          textColor: [255, 255, 255],
          halign: 'center',
          valign: 'middle',
          fontStyle: 'bold',
        },

        tableWidth: usableWidth,

        margin: {
          top: 40,
          left: marginLeft,
          right: marginRight,
        },

        didDrawPage: () => {
          addHeader();
          addFooter();
        },
      });
    }
    /* ---------------- END OF REPORT ---------------- */
    const endY = (doc as any).lastAutoTable.finalY;
    doc.setFontSize(9);
    doc.text(
      'This is computer generated Report. No Signature Required.',
      doc.internal.pageSize.width / 2,
      endY + 10,
      { align: 'center' }
    );

    doc.text(
      ` Printed on ${CurentDate.split('-').reverse().join('-')} at ${CurrentTime} by ${user_mobile}`,
      65,
      endY + 15
    );

    doc.text('* End of Report *', doc.internal.pageSize.width / 2, endY + 20, {
      align: 'center',
    });

    /* ---------------- PAGE NUMBERS ---------------- */
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        String(i),
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    /* ---------------- SAVE ---------------- */
    doc.save(`${table_name}.pdf`);
  }

  async generatePDF_enq_report(
    table_card_1,
    table_id,
    table_card_2,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    if (this.alert_exist == false) {
      this.alert_exist = true;

      this.newConfirmationAlert({
        text: 'Are You Sure Want To Download The PDF ?',
        confirmCallback: () => {
          this.Confirm_generatePDF_2(
            table_card_1,
            table_id,
            table_card_2,
            table_heading,
            table_name,
            font_size
          );
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.newWarningAlert({
            text: 'cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_generatePDF_2(
    table_card_1,
    table_id,
    table_card_2,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    const doc = new jsPDF();
    const logoURL = '/assets/icon/logo_opaq.png'; // Replace with the correct path to your company logo image
    const addHeader = () => {
      doc.addImage(logoURL, 'JPEG', 10, 10, 40, 15);
      doc.setTextColor(100, 107, 111);
    };

    addHeader();
    const leftFooterContent = '+91 9489715036';
    const rightFooterContent = 'postulate.in';

    const CurentDate = new Date().toISOString().substring(0, 10);
    const CurrentTime = new Date().toLocaleTimeString('en-US', {
      hour12: true,
    });
    const user_mobile = this.localStorage.getItem('mobile');

    const customFooter = (data: any) => {
      // Left footer
      doc.setFontSize(10);
      doc.text(leftFooterContent, 10, doc.internal.pageSize.height - 10);
      // Right footer
      doc.text(
        rightFooterContent,
        doc.internal.pageSize.width - 50,
        doc.internal.pageSize.height - 10
      );
    };

    // Create an HTML structure for the card content
    // const cardContent = document.querySelector('#card');

    const cardData = document.getElementById(table_card_1);
    const tableData = [document.getElementById(table_id)];
    const card2Data = document.getElementById(table_card_2);

    const card1TableParams = {
      theme: 'plain',
      startY: 38, // Adjust the Y coordinate to make space for the header
      body: cardData,
      styles: {
        fontSize: 8,
        halign: 'left', // Adjust text alignment as needed
        fontStyle: 'bold',
        cellWidth: 60, // Set a fixed column width
        cellSpace: 3,
      },
    };
    const card2TableParams = {
      theme: 'plain',
      //startY: 38, // Adjust the Y coordinate to make space for the header
      body: card2Data,
      styles: {
        fontSize: 8,
        halign: 'left', // Adjust text alignment as needed
        fontStyle: 'bold',
        //cellWidth: 60, // Set a fixed column width
        cellSpace: 3,
        cellWidth: 'warp',
      },
    };
    // to set table heading
    doc.setFontSize(16);
    doc.setTextColor(0);
    // (doc as any).setFont('bold');
    const captionText = table_heading;
    const textWidth =
      (doc.getStringUnitWidth(captionText) *
        (doc as any).internal.getFontSize()) /
      doc.internal.scaleFactor;
    const xOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(captionText, xOffset, 30);

    const tableParams = {
      // theme: 'plain',
      // startY: 60, // Adjust the Y coordinate to make space for the header
      //addPageContent: customFooter,
      // addPageContent1: customHeader,
      didDrawPage: (data) => {
        addHeader(); // Add header on each new page
        customFooter(data); // Add footer on each page
      },
      fontStyle: 'bold',
      body: tableData,
      styles: {
        fontSize: font_size, // Set the font size for the table content
        halign: 'center', // Right-aligned body text
        fontStyle: 'bold',
        cellWidth: 'warp', // Set a fixed column width
      },

      headStyles: {
        // Customize styles for the table headings
        fillColor: [108, 11, 169], // Background color as RGB (red)
        textColor: [255, 255, 255], // Text color as RGB (white)
        fontSize: font_size,
        halign: 'center',
        cellWidth: 'warp', // Set a fixed column width
        fontStyle: 'bold',
      },
      tableWidth: 190, //'190' 'auto' or 'wrap' to adjust table width automatically or 'wrap' to fit content
      margin: { top: 40, left: 10 },
      // Your table data here
    };

    // Add your table content for multiple pages
    // const tableData = [document.getElementById('curr_table')];

    // Function to add the table to the PDF
    const addTableToPDF = () => {
      (doc as any).autoTable({ html: '#' + table_id, ...tableParams });
    };
    const addCard1ToPDF = (card1Table: HTMLElement | null, params: any) => {
      if (card1Table) {
        (doc as any).autoTable({ html: card1Table, ...params });
      }
    };
    addCard1ToPDF(cardData, card1TableParams);
    const addCard2ToPDF = (card2Table: HTMLElement | null, params: any) => {
      if (card2Table) {
        (doc as any).autoTable({ html: card2Table, ...params });
      }
    };

    // Loop to add the table content
    for (let i = 0; i < tableData.length; i++) {
      addTableToPDF();
      addCard2ToPDF(card2Data, card2TableParams);
      if (i === tableData.length - 1) {
        // Define your middle footer content
        const middleFooterContent =
          'This is computer generated Report. No Signature Required.' +
          ' Printed on ' +
          (CurentDate.split('-')[2] +
            '-' +
            CurentDate.split('-')[1] +
            '-' +
            CurentDate.split('-')[0]) +
          ' at ' +
          CurrentTime +
          ' by ' +
          user_mobile +
          '';
        const middleFooterContent1 =
          '                            * End of Report *';
        doc.setFontSize(9);
        doc.text(middleFooterContent, 65, (doc as any).autoTableEndPosY() + 10);
        doc.text(
          middleFooterContent1,
          65,
          (doc as any).autoTableEndPosY() + 17
        );
      }
    }

    // Adding Page Numbers
    const pageCount = (doc as any).internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(
        '' + i,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // Save or display the PDF
    doc.save(table_name + '.pdf');
  }

  Confirm_multi_generatePDF(
    table_cards: string[],
    table_ids: string[],
    table_headings = ['REPORT'],
    table_names = ['REPORT'],
    font_size = 8,
    reportName: string = 'REPORT',
    excludeColumns: string[][] = []
  ) {
    const doc = new jsPDF();

    const rootStyles = getComputedStyle(document.documentElement);

    const tableHeaderColor = rootStyles
      .getPropertyValue('--table_header_back_color')
      .trim();
    const tableTextColor = rootStyles
      .getPropertyValue('--table_header_text_color')
      .trim();
    const tableBgColor = rootStyles
      .getPropertyValue('--table_back_color')
      .trim();
    const headerBg = this.cssColorToRgb(tableHeaderColor);
    const headerText = this.cssColorToRgb(tableTextColor);
    const tableBg = this.cssColorToRgb(tableBgColor);

    const logoURL = this.set_brand_logo();
    doc.addImage(logoURL, 'JPEG', 10, 10, 40, 15);

    const leftFooterContent = '+91 ' + this.localStorage.getItem('cmp_contact');

    const rightFooterContent = this.localStorage.getItem('cmp_website');

    const CurentDate = new Date().toISOString().substring(0, 10);
    const CurrentTime = new Date().toLocaleTimeString('en-US', {
      hour12: true,
    });
    const user_mobile = this.localStorage.getItem('mobile');

    const customFooter = () => {
      doc.setFontSize(10);
      doc.text(leftFooterContent, 10, doc.internal.pageSize.height - 10);
      doc.text(
        rightFooterContent,
        doc.internal.pageSize.width - 50,
        doc.internal.pageSize.height - 10,
      );
    };

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');

    doc.text(reportName, doc.internal.pageSize.width / 2, 20, {
      align: 'center',
    });

    let currentY = 25;

    for (let i = 0; i < table_ids.length; i++) {
      const cardData = document.getElementById(table_cards[i]);
      const tableData = document.getElementById(table_ids[i]);

      // ✅ Heading
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');

      doc.text(table_headings[i], doc.internal.pageSize.width / 2, currentY, {
        align: 'center',
      });

      currentY += 8;

      // ✅ CARD
      if (cardData) {
        (doc as any).autoTable({
          html: cardData,
          startY: currentY,
          theme: 'plain',
          styles: {
            fontSize: 9,
            cellPadding: 2,
            textColor: [40, 40, 40],
          },

          tableLineWidth: 0,
          margin: { left: 10, right: 10 },

          didParseCell: (data: any) => {
            if (data.section === 'body') {
              data.cell.styles.fillColor = [250, 250, 250]; // light background
            }
          },

          didDrawCell: (data: any) => {
            // optional left border highlight
            if (data.column.index === 0) {
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.textColor = [0, 0, 0];
            }
          },
        });

        currentY = (doc as any).lastAutoTable.finalY + 3;
      }

      // ✅ TABLE
      if (tableData) {
        const excluded = excludeColumns[i] || [];

        const headerCells = tableData.querySelectorAll('thead th');
        const excludedIndices: number[] = [];
        headerCells.forEach((th, index) => {
          if (excluded.includes((th as HTMLElement).innerText.trim())) {
            excludedIndices.push(index);
          }
        });

        (doc as any).autoTable({
          html: tableData, // ✅ direct element (no selector error)
          startY: currentY,
          theme: 'grid',
          styles: {
            // fontSize: font_size,
            halign: 'left',
            fontSize: font_size,
            cellPadding: 3,
            lineColor: [200, 200, 200],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: headerBg, // ✅ header background from SCSS
            textColor: headerText,
            halign: 'center',
            fontStyle: 'bold',
          },
          footStyles: {
            fillColor: headerBg, // ✅ footer same as header
            textColor: headerText,
            fontStyle: 'bold',
            halign: 'right',
          },
          margin: { left: 10, right: 10 },
          didParseCell: (data: any) => {
            console.log(data);
            if (excludedIndices.includes(data.column.index)) {
              data.cell.text = [''];
              data.cell.styles.cellWidth = 0.1;
              data.cell.styles.overflow = 'hidden';
              data.cell.styles.fillColor = false;
              data.cell.styles.lineWidth = 0;
            }
            if (data.section === 'body') {
              if (data.row.index % 2 === 1) {
                data.cell.styles.fillColor = [245, 245, 245]; // light gray rows
              }

              const cellText = data.cell.text?.toString().trim();

              console.log('Cell Value:', cellText);
              if (
                cellText.toLowerCase().includes('tot') ||
                cellText.toLowerCase().includes('amt')
              ) {
                for (const key in data.row.cells) {
                  if (data.row.cells.hasOwnProperty(key)) {
                    const cell = data.row.cells[key];
                    cell.styles.fontStyle = 'bold';
                    cell.styles.textColor = 0;
                  }
                }
              }

              // ✅ If cell is a valid number, align it right
              else if (
                /^\d+(\.\d+)?\s*\w*$/.test(cellText.replace(/,/g, '').trim())
              ) {
                data.cell.text = [cellText]; // Keep original text format
                data.cell.styles.halign = 'right'; // Align right for numbers

                data.cell.styles.cellWidth = 'auto';
                data.cell.styles.overflow = 'visible';
                data.cell.styles.whiteSpace = 'nowrap';
              }

              if (data.section == 'foot') {
                data.cell.styles.halign = 'right';

                data.cell.styles.cellWidth = 'auto';
                data.cell.styles.overflow = 'visible';
                data.cell.styles.whiteSpace = 'nowrap';
              }
            }
          },
          didDrawPage: function (data: any) {
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;

            // 🔥 LOW OPACITY FOR WATERMARK
            doc.setGState(new (doc as any).GState({ opacity: 0.08 }));

            // 🔥 CENTER LOGO WATERMARK
            const imgWidth = 120;
            const imgHeight = 80;

            const x = (pageWidth - imgWidth) / 2;
            const y = (pageHeight - imgHeight) / 2;

            doc.addImage(logoURL, 'JPEG', x, y, imgWidth, imgHeight);

            // 🔥 RESET OPACITY (IMPORTANT)
            doc.setGState(new (doc as any).GState({ opacity: 1 }));

            // your footer still on top
            customFooter();
          },
        });

        currentY = (doc as any).lastAutoTable.finalY + 10;
      }

      // ✅ Page break for next table
      if (i < table_ids.length - 1) {
        doc.addPage();

        // ✅ Add logo again for new page
        doc.addImage(logoURL, 'JPEG', 10, 10, 40, 15);

        // ✅ Reset proper Y (based on logo height)
        currentY = 30;
      }

      // ✅ Last footer
      if (i === table_ids.length - 1) {
        const middleFooterContent =
          'Printed on ' +
          (CurentDate.split('-')[2] +
            '-' +
            CurentDate.split('-')[1] +
            '-' +
            CurentDate.split('-')[0]) +
          ' at ' +
          CurrentTime +
          ' by ' +
          user_mobile;

        doc.setFontSize(9);

        doc.text(
          middleFooterContent,
          20,
          (doc as any).lastAutoTable.finalY + 10,
        );

        doc.text(
          '* End of Report *',
          doc.internal.pageSize.width / 2,
          (doc as any).lastAutoTable.finalY + 18,
          { align: 'center' },
        );
      }
    }

    // ✅ Page Numbers
    const pageCount = (doc as any).internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(
        '' + i,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' },
      );
    }

    doc.save(table_names[0] + '.pdf');
  }



  cssColorToRgb(color: string) {
    const temp = document.createElement('div');
    temp.style.color = color;
    document.body.appendChild(temp);

    const computed = getComputedStyle(temp).color;
    document.body.removeChild(temp);

    const rgb = computed.match(/\d+/g);
    return rgb ? rgb.map(Number) : [0, 0, 0];
  }


  // To convert a table to exel format
  async convertTableToCSV(tableId: string, fileName: string = 'Report') {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      this.newConfirmationAlert({
        text: 'Are You Sure Want To Download The CSV File ?',
        confirmCallback: () => {
          this.Confirm_convertTableToCSV(tableId, fileName);
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.newWarningAlert({
            text: 'Cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_convertTableToCSV(tableId: string, fileName: string = 'report') {
    // Get the HTML table element by its ID
    const table = document.getElementById(tableId);

    // Check if the table exists
    if (!table) {
      // console.error(Table with ID "${tableId}" not found.);
      return;
    }

    // Extract table data (rows and cells) and prepare CSV content
    const rows = table.querySelectorAll('tr');
    const csvContent = Array.from(rows, (row) =>
      Array.from(row.querySelectorAll('td, th'), (cell) =>
        cell.textContent.trim()
      ).join(',')
    ).join('\n');

    // Create a blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);

    // Append the link to the document body and trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  alert = {
    warningAlert: this.warningAlert,
    confirmationAlert: this.confirmationAlert,
    newWarningAlert:this.newWarningAlert,
    newConfirmationAlert:this.newConfirmationAlert,
    toastAlert:this.toastAlert
  };

  private warningAlert(props: {
    title?: string;
    text: string;
    action?: 'success' | 'update' | 'delete' | 'warning' | 'error';
    iconColor?: string;
    iconHtml?: string;
    btnColor?: string;
    btnText?: string;
    callback?: () => void;
    // customClass?: {
    //   [key: string]: string
    // }
  }) {
    const {
      title,
      text,
      action,
      iconColor,
      btnColor,
      btnText,
      iconHtml,
      callback,
    } = props;
    let sweetAlertIcon: SweetAlertIcon;
    let setColor: string;
    let setIconHtml: string;
    let setTitle: string;

    switch (action) {
      case 'success':
        setTitle = 'Successful';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#30a702';
        break;
      case 'update':
        setTitle = 'Updated';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#0000FF';
        break;
      case 'delete':
        setTitle = 'Deleted';
        setIconHtml =
          '<i class="fa-regular fa-trash-can fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      case 'warning':
        setTitle = 'Warning!';
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#F6BE00';
        break;
      case 'error':
        setTitle = 'Error!';
        setIconHtml =
          '<i class="fa-solid fa-x fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      default:
        setTitle = '';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
    }

    setColor = iconColor || setColor;

    let iconProps: { iconHtml?: string; icon?: SweetAlertIcon } = {
      iconHtml: iconHtml || setIconHtml,
    };
    if (!iconProps.iconHtml) {
      iconProps = { icon: sweetAlertIcon };
    }

    Swal.fire({
      title: title || setTitle,
      html: text,
      iconColor: setColor,
      confirmButtonColor: btnColor || '#6C0BA9',
      confirmButtonText: btnText || 'OK',
      customClass: {
        popup: 'cus-sweet-alert',
        // title: 'custom-title-class',
        // icon: 'custom-icon-class',
        // Add other classes as needed
      },
      ...iconProps,
      // customClass: {
      //   icon: 'no-border'
      // },
    }).then(callback);

    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }

  private confirmationAlert(props: {
    title?: string;
    text: string;
    action?: 'delete' | 'warning' | 'logout' | 'print';
    iconColor?: string;
    iconHtml?: string;
    confirmBtnText?: string;
    confirmBtnColor?: string;
    cancelBtnText?: string;
    cancelBtnColor?: string;
    confirmCallback?: () => void;
    cancelCallback?: () => void;
  }) {
    const {
      title,
      text,
      action,
      iconColor,
      iconHtml,
      confirmBtnText,
      confirmBtnColor,
      cancelBtnText,
      cancelBtnColor,
      confirmCallback = () => { },
      cancelCallback = () => { },
    } = props;
    let sweetAlertIcon: SweetAlertIcon;
    let setColor: string;
    let setIconHtml: string;

    switch (action) {
      case 'delete':
        setIconHtml =
          '<i class="fa-regular fa-trash-can fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      case 'warning':
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#F6BE00';
        break;
      case 'logout':
        setIconHtml =
          '<i class="fa-solid fa-arrow-right-from-bracket fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
      case 'print':
        setIconHtml =
          '<i class="fa-solid fa-print fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#0000FF'; // Blue color for print
        break;
      default:
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
    }

    setColor = iconColor || setColor;

    let iconProps: { iconHtml?: string; icon?: SweetAlertIcon } = {
      iconHtml: iconHtml || setIconHtml,
    };
    if (!iconProps.iconHtml) {
      iconProps = { icon: sweetAlertIcon };
    }

    Swal.fire({
      title: title || 'Are you sure?',
      html: text,
      iconColor: setColor,
      showCancelButton: true,
      confirmButtonText: confirmBtnText || 'Confirm',
      confirmButtonColor: confirmBtnColor || '#6C0BA9',
      cancelButtonText: cancelBtnText || 'Cancel',
      cancelButtonColor: cancelBtnColor,
      // reverseButtons: true,
      customClass: {
        popup: 'cus-sweet-alert',
        // title: 'custom-title-class',
        // icon: 'custom-icon-class',
        // Add other classes as needed
      },
      ...iconProps,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
      } else if (
        result.isDismissed &&
        result.dismiss === Swal.DismissReason.cancel
      ) {
        cancelCallback();
      }
    });
    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }
private newWarningAlert(props: {
  title?: string;
  text: string;
  action?: 'success' | 'update' | 'delete' | 'warning' | 'error';
  iconColor?: string;
  iconHtml?: string;
  btnColor?: string;
  btnText?: string;
  callback?: () => void;
}) {

  const {
    title,
    text,
    action = 'warning',
    iconColor,
    iconHtml,
    btnColor,
    btnText = 'OK',
    callback
  } = props;

  let setTitle = '';
  let setColor = '';
  let setIcon = '';

  switch (action) {

    case 'success':
      setTitle = 'Success';
      setColor = '#16a34a';
      setIcon = `
        <i class="fa-solid fa-check"></i>
      `;
      break;

    case 'update':
      setTitle = 'Updated';
      setColor = '#2563eb';
      setIcon = `
        <i class="fa-solid fa-check"></i>
      `;
      break;

    case 'delete':
      setTitle = 'Deleted';
      setColor = '#dc2626';
      setIcon = `
        <i class="fa-regular fa-trash-can"></i>
      `;
      break;

    case 'error':
      setTitle = 'Error';
      setColor = '#dc2626';
      setIcon = `
        <i class="fa-solid fa-xmark"></i>
      `;
      break;

    case 'warning':
    default:
      setTitle = 'Warning';
      setColor = '#e5a900';
      setIcon = `
        <i class="fa-solid fa-exclamation"></i>
      `;
      break;
  }

  const finalColor = iconColor || setColor;
  const finalIcon = iconHtml || setIcon;

  Swal.fire({

    title: '',

    html: `
      <div
        class="modern-erp-alert"
        style="--alert-color: ${finalColor};"
      >

        <div class="modern-alert-top">

          <div class="modern-alert-icon">
            ${finalIcon}
          </div>

          <div class="modern-alert-content">

            <div class="modern-alert-title">
              ${title || setTitle}
            </div>

            <div class="modern-alert-message">
              ${text}
            </div>

          </div>

        </div>

        <div class="modern-alert-footer">

          <button
            type="button"
            class="modern-alert-button"
            id="modernAlertOk"
            style="background-color: ${btnColor || '#6C0BA9'};"
          >
            ${btnText}
          </button>

        </div>

      </div>
    `,

    showConfirmButton: false,

    showCloseButton: true,

    allowOutsideClick: true,

    allowEscapeKey: true,

    backdrop: `
      rgba(15, 23, 42, 0.35)
    `,

    customClass: {
      popup: 'modern-erp-alert-popup',
      closeButton: 'modern-alert-close'
    },

    showClass: {
      popup: 'modern-alert-show'
    },

    hideClass: {
      popup: 'modern-alert-hide'
    },

    didOpen: () => {

      const okButton =
        document.getElementById('modernAlertOk');

      okButton?.addEventListener('click', () => {

        Swal.close();

        if (callback) {
          callback();
        }

      });

      document.body.classList.remove(
        'swal2-height-auto'
      );
    }

  });

  document.body.classList.remove(
    'swal2-height-auto'
  );
}
private newConfirmationAlert(props: {
  title?: string;
  text: string;
  action?: 'delete' | 'warning' | 'logout' | 'print';
  iconColor?: string;
  iconHtml?: string;
  confirmBtnText?: string;
  confirmBtnColor?: string;
  cancelBtnText?: string;
  cancelBtnColor?: string;
  confirmCallback?: () => void;
  cancelCallback?: () => void;
}) {
  const {
    title,
    text,
    action = 'warning',
    iconColor,
    iconHtml,
    confirmBtnText,
    confirmBtnColor,
    cancelBtnText,
    cancelBtnColor,
    confirmCallback = () => {},
    cancelCallback = () => {},
  } = props;

  let setColor = '#F6BE00';
  let setIconHtml = '';

  switch (action) {

    case 'delete':
      setIconHtml = `
        <i class="fa-regular fa-trash-can confirmation-alert-icon"></i>
      `;
      setColor = '#FF0000';
      break;

    case 'warning':
      setIconHtml = `
        <i class="fa-solid fa-exclamation confirmation-alert-icon"></i>
      `;
      setColor = '#F6BE00';
      break;

    case 'logout':
      setIconHtml = `
        <i class="fa-solid fa-arrow-right-from-bracket confirmation-alert-icon"></i>
      `;
      setColor = '#6C0BA9';
      break;

    case 'print':
      setIconHtml = `
        <i class="fa-solid fa-print confirmation-alert-icon"></i>
      `;
      setColor = '#0000FF';
      break;

    default:
      setIconHtml = `
        <i class="fa-solid fa-exclamation confirmation-alert-icon"></i>
      `;
      setColor = '#F6BE00';
      break;
  }

  setColor = iconColor || setColor;

  Swal.fire({
    title: title || 'Warning',
    html: `
      <div class="confirmation-alert-message">
        ${text}
      </div>
    `,

    iconHtml: iconHtml || setIconHtml,
    iconColor: setColor,

    showCancelButton: true,

    confirmButtonText: confirmBtnText || 'OK',
    confirmButtonColor: confirmBtnColor || '#6C0BA9',

    cancelButtonText: cancelBtnText || 'Cancel',
    cancelButtonColor: cancelBtnColor || '#E5E7EB',

    customClass: {
      popup: 'cus-confirmation-alert',
      icon: 'confirmation-alert-icon-wrapper',
      title: 'confirmation-alert-title',
      htmlContainer: 'confirmation-alert-content',
      actions: 'confirmation-alert-actions',
      confirmButton: 'confirmation-alert-confirm-btn',
      cancelButton: 'confirmation-alert-cancel-btn',
    },

    buttonsStyling: true,

    allowOutsideClick: false,
    allowEscapeKey: true,

  }).then((result) => {

    if (result.isConfirmed) {
      confirmCallback();
    }

    else if (
      result.isDismissed &&
      result.dismiss === Swal.DismissReason.cancel
    ) {
      cancelCallback();
    }

  });

  document.body.classList.remove('swal2-height-auto');
}
toastAlert(props: {
  text: string;
  action?: 'success' | 'update' | 'delete' | 'warning' | 'error' | 'info';
  iconColor?: string;
  iconHtml?: string;
  timer?: number;
  callback?: () => void;
}) {

  const {
    text,
    action = 'info',
    iconColor,
    iconHtml,
    timer = 3000,
    callback
  } = props;

  let setColor: string;
  let setIconHtml: string;

  switch (action) {

    case 'success':
      setColor = '#22c55e';
      setIconHtml = '<i class="fa-solid fa-check"></i>';
      break;

    case 'update':
      setColor = '#3b82f6';
      setIconHtml = '<i class="fa-solid fa-pen"></i>';
      break;

    case 'delete':
      setColor = '#ef4444';
      setIconHtml = '<i class="fa-regular fa-trash-can"></i>';
      break;

    case 'warning':
      setColor = '#f59e0b';
      setIconHtml = '<i class="fa-solid fa-exclamation"></i>';
      break;

    case 'error':
      setColor = '#ef4444';
      setIconHtml = '<i class="fa-solid fa-xmark"></i>';
      break;

    case 'info':
    default:
      setColor = '#3b82f6';
      setIconHtml = '<i class="fa-solid fa-info"></i>';
      break;
  }

  setColor = iconColor || setColor;

  Swal.fire({

    toast: true,
    position: 'top-end',
    backdrop: false,

    html: `
      <div class="custom-toast-content">

        <div class="custom-toast-icon">
          ${iconHtml || setIconHtml}
        </div>

        <div class="custom-toast-message">
          ${text}
        </div>

      </div>
    `,

    showConfirmButton: false,
    showCloseButton: false,

    timer: timer,
    timerProgressBar: true,

    width: '420px',
    padding: 0,

    customClass: {
      popup: 'custom-toast-popup'
    },

    didOpen: () => {

      const popup = document.querySelector(
        '.custom-toast-popup'
      ) as HTMLElement;

      if (popup) {

        popup.style.setProperty(
          '--toast-color',
          setColor
        );

        popup.style.setProperty(
          '--toast-glow',
          `${setColor}55`
        );
      }
    },

    // ⭐ Toast close ஆனதும் callback execute ஆகும்
    didClose: () => {

      if (callback) {
        callback();
      }

    }

  });
}
  // // Define showSweetAlert_forDelete function
  // showSweetAlert_forDelete(title: string, text: string) {
  //   const handleResult = (result: any) => {
  //     if (result.isConfirmed) {
  //       showResultAlert("Deleted!", "Your file has been deleted.", "success");
  //     } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
  //       showResultAlert("Cancelled", "Your file is safe", "error");
  //     }
  //     document.body.classList.remove('swal2-height-auto');
  //   };

  //   Swal.fire({
  //     title: title,
  //     text: text,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "No, cancel!",
  //     reverseButtons: true
  //   }).then(handleResult);
  // }

  relational_date_validation(startDate, endDate) {
    if (new Date(startDate) < new Date(endDate)) {
      return true;
    } else if (new Date(startDate) > new Date(endDate)) {
      return false;
    }
  }

  validate_aadhaar_no(txt: string) {
    let aadhar_regex = /^[2-9]{1}[0-9]{11}$/;
    return !aadhar_regex.test(txt);
  }

  validate_pan_no(txt: string) {
    let pan_regex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
    return !pan_regex.test(txt);
  }

  validate_email(txt: string) {
    let email_regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{3,}))$/;
    // let email_regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    // /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    return email_regex.test(String(txt));
  }

  validate_phone_no(txt: string) {
    // Check if it has exactly 10 digits and is not all zeros
    return /^\d{10}$/.test(txt) && txt !== '0000000000';
  }

  validate_fileupload(
    file: File,
    valid_props?: {
      types?: string[];
      min_size?: number;
      max_size?: number;
      accepted_types?: string;
    }
  ) {
    valid_props.min_size = valid_props.min_size || 0.125;
    valid_props.max_size = valid_props.max_size || this.MAX_FILESIZE_COMMON;
    valid_props.types = valid_props.types || ['image/*, application/pdf'];
    valid_props.accepted_types = valid_props.accepted_types || 'Images, PDF';

    let file_size = file.size;
    let file_type = file.type;

    if (file_size == 0 || file_size < valid_props.min_size) {
      return { status: false, message: 'Invalid File Size' };
    }

    if (file_size > valid_props.max_size) {
      return {
        status: false,
        message:
          'Uploaded File Size is more than allowed limit of ' +
          valid_props.max_size / 1024 +
          'KB',
      };
    }

    let wildCardFileTypes = valid_props.types.filter((type_txt) =>
      type_txt.includes('*')
    );
    if (wildCardFileTypes.length > 0) {
      let nonWildCardFileTypes = valid_props.types.filter(
        (type_txt) => !type_txt.includes('*')
      );
      if (!nonWildCardFileTypes.includes(file_type)) {
        let fileTypeNotAccepted = true;
        for (let testFileType of wildCardFileTypes) {
          let checkTypeStr = testFileType.substring(
            0,
            testFileType.indexOf('/')
          );
          // console.log({ checkTypeStr });
          let fTypeRegex = new RegExp(
            `^${checkTypeStr}\/[\\-\\.\\w]+(?:\\+[\\-\\.\\w]+)?`
          ); // eg: /image\//
          // console.log({ fTypeRegex });

          let fileTypeAccepted = fTypeRegex.test(file_type);
          if (fileTypeAccepted) {
            fileTypeNotAccepted = false;
            break;
          }
        }
        if (fileTypeNotAccepted) {
          return {
            status: false,
            message:
              'Uploaded File Type is not accepted. Accepted Types: ' +
              valid_props.accepted_types,
          };
        }
      }
    } else {
      if (!valid_props.types.includes(file_type)) {
        return {
          status: false,
          message:
            'Uploaded File Type is not accepted. Accepted Types: ' +
            valid_props.accepted_types,
        };
      }
    }

    return { status: true };
  }

  // to check if the text contains only alpabets (a-z) or (A-Z)
  check_only_alphabet(id) {
    var text = $(id).val();
    var regapha = /^[A-Za-z]+$/;
    return regapha.test(String(text)) || text == '';
  }

  // only allow ALphapets
  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/^[a-zA-Z\s]$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  // Only Integer Numbers
  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // Only Integer Numbers and Dot
  keyPressNumbersAndDot(event) {
    // var charCode = event.which ? event.which : event.keyCode;
    var inp = String.fromCharCode(event.keyCode);
    if (/^[\.0-9]$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  postData_with_stringUrl(
    url: string,
    data: any,
    stringData: any,
    responseType: any
  ): Observable<any> {
    const httpOptions = {
      url: url,
      method: 'POST',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.get_session_id_login(),
        modname: stringData,
      }),
      responseType: responseType,
    };

    return this.http.post(url, data, httpOptions);
  }

  refresh_captcha(options: {
    modname: string;
    captchaInputSelector: string;
    captchaImgSelector: string;
    onCaptchaLoad?: () => void;
    onCaptchaLoadErr?: (err) => void;
  }) {
    this.hide_refresh_button = true;
    let {
      modname,
      captchaInputSelector, // = '#capt',
      captchaImgSelector = "[name='captcha2']",
      onCaptchaLoad = () => {
        this.hide_refresh_button = false;
      },
      onCaptchaLoadErr = (err) => {
        this.hide_refresh_button = false;
      },
    } = options;

    // console.log(modname, 'Checking ');
    if (captchaInputSelector) $(captchaInputSelector).val('');

    let cpt_key = this.cpt_views[modname]['cptid-keyname'];
    // console.log(
    //   'test cpt id :',
    //   this.cpt_views[modname],
    //   this.cpt_session_keys[modname],
    //   this.localStorage.getItem(cpt_key)
    // );
    // console.log('test', this.api.localStorage.getItem(cpt_key))
    fetch(environment.API_URL + 'captcha/captcha_image', {
      // credentials: 'include',  // to use set-cookie header
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // to reuse the session used to load previous captcha if page already loaded
        // to reuse the session used in verify mobile number section of registration pages
        last_used_cptid: this.localStorage.getItem(cpt_key) || '',
        modname,
      }),
    })
      .then((res) => {
        this.cpt_session_keys[modname] = res.headers.get('x-cptid') || '';
        // if (environment.production) {
        //   // console.log('test cookie :', this.cookies.get('postulate_sid'));
        //   // this.cpt_session_key = this.cookies.get(cpt_key);
        // }
        // console.log(this.cpt_session_keys);
        this.localStorage.setItem(cpt_key, this.cpt_session_keys[modname]);

        return res.blob();
      })
      .then((blob) => {
        let URLcreator = window.URL || window.webkitURL;
        let captImgTempUrl = URLcreator.createObjectURL(blob);
        let $capt_img = $(captchaImgSelector);
        $capt_img.attr('src', captImgTempUrl);
        $capt_img[0].onload = () => {
          URLcreator.revokeObjectURL(captImgTempUrl);
          onCaptchaLoad();
        };
      })
      .catch((err) => {
        console.log(err);
        onCaptchaLoadErr(err);
      });
  }

  verify_captcha(options: {
    modname: string;
    captchaInputSelector: string;
    captchaInputVal: string;
    captchaImgSelector: string;
    onCaptchaVerified?: (res) => void;
    onComplete?: () => void;
  }) {
    const {
      modname,
      captchaInputSelector,
      captchaInputVal,
      captchaImgSelector,
      onCaptchaVerified = (res) => { },
      onComplete = () => { },
    } = options;
    let errCallBk = this.common_errorCb;

    let cpt_key = this.cpt_views[modname]['cptid-keyname'];
    let captcha_data = {
      captcha_entered: captchaInputVal,
      cpt_id: this.localStorage.getItem(cpt_key) || '',
      modname,
    };
    // console.log(captcha_data);

    this.call_http_post({
      url: environment.API_URL + 'captcha/verify_captcha',
      data: captcha_data,
      successCb: (result) => {
        try {
          let { verified = false, message, session = 'valid' } = result.data;
          if (!verified) {
            onComplete();
            if (message) {
              // Show Captcha Input Validation Error Message
              this.alert.newWarningAlert({
                text: message,
                action: 'error',
                callback: () => {
                  setTimeout(function () {
                    $(captchaInputSelector).focus();
                  }, 500);
                },
              });
            } else {
              let expiredCaptcha = session == 'invalid';
              this.alert.newWarningAlert({
                text: expiredCaptcha ? 'Captcha Expired' : 'Invalid Captcha',
                action: 'error',
                callback: () => {
                  if (expiredCaptcha) {
                    this.refresh_captcha({
                      modname,
                      captchaInputSelector,
                      captchaImgSelector,
                    });
                  }
                  setTimeout(function () {
                    $(captchaInputSelector).focus();
                  }, 500);
                },
              });
            }
            return;
          }
        } catch (error) {
          errCallBk(error);
          onComplete();
        }
        onCaptchaVerified(result);
      },
      afterError: () => {
        onComplete();
      },
    });
  }

  setSession(): Observable<any> {
    return this.http.get(`${environment.API_URL}set_session/`, {
      withCredentials: true,
    });
  }

  getSession(): Observable<any> {
    return this.http.get(`${environment.API_URL}get_session/`, {
      withCredentials: true,
    });
  }

  validateFileSize25Mp(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      const maxSizeInBytes = 25 * 1024 * 1024; // 2 MB
      // const maxSizeInBytes = 200 * 1024; // 200 KB

      if (file.size > maxSizeInBytes) {
        this.alert.newWarningAlert({
          text: 'File Size Must be Less than 25 MB.',
          action: 'warning',
          callback: () => { },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false;
      } else {
        return true;
      }
    }
  }

  // to open file in new tab

  view_privew_url(doc) {
    var url = environment.API_URL + 'media' + '/' + doc;
    window.open(url, '_blank');
  }

  view_privew_url_src_only(doc) {
    var url = environment.API_URL + 'media' + '/' + doc;
    return url;
  }

  view_down_url_src_only(doc: string): string {
    // Generate the full URL for the document
    const url = environment.API_URL + 'media' + '/' + doc;
    return url;
  }

  get_privilage_function(onDone = () => { }) {
    var obj = {
      user_id: this.localStorage.getItem('user_id'),
      user_type: this.localStorage.getItem('user_type'),
    };

    this.call_http_post({
      url: environment.API_URL + 'mastermodule/get_privilage_function',
      data: obj,
      successCb: (res: any) => {
        let result = res.data;
        // console.log('privilage _function_res :', { result });
        let { dt = [], message } = result;
        let list_of_page_prv_objs: {
          page_id: number;
          modname: string;
          pagename: string;
          page_allow: string | number;
          view_allow: string | number;
          print_allow: string | number;
          add_allow: string | number;
          edit_allow: string | number;
          delete_allow: string | number;
        }[] = dt;
        // only allowed / viewable active pages

        console.log(list_of_page_prv_objs, 'list_of_page_prv_objs');
        list_of_page_prv_objs = list_of_page_prv_objs.filter(
          (prv) => prv.page_allow == '1' && prv.view_allow == '1'
        );

        this.privilage_array = list_of_page_prv_objs.map((pg_prv) =>
          String(pg_prv.page_id)
        );
        console.log(this.privilage_array, 'common privilage_array');

        this.saved_nav_stack = list_of_page_prv_objs;

        onDone();
      },
    });
    //   this.previewMenubar()
  }

  set_brand_logo(id = 'logo_image') {
    var cmp_logo = this.localStorage.getItem('cmp_logo');
    var media_url = this.localStorage.getItem('media_url');

    // Create a URL for the image blob using createObjectURL

    try {
      const imageElement = document.getElementById(id) as HTMLImageElement;

      const imageURL = environment.API_URL + media_url + '/' + cmp_logo;
      // Set the 'src' attribute of the <img> element to the URL
      imageElement.src = imageURL;

      return environment.API_URL + media_url + '/' + cmp_logo;
    } catch {
      return environment.API_URL + media_url + '/' + cmp_logo;
    }

    return environment.API_URL + media_url + '/' + cmp_logo;
  }

  set_brand_logo2(id = 'logo_image') {
    var cmp_logo = this.localStorage.getItem('cmp_logo');
    var media_url = this.localStorage.getItem('media_url');

    // Create a URL for the image blob using createObjectURL

    try {
      const imageElement = document.getElementById(id) as HTMLImageElement;

      const imageURL = environment.API_URL + media_url + '/' + cmp_logo;
      // Set the 'src' attribute of the <img> element to the URL
      imageElement.src = imageURL;

      return environment.API_URL + media_url + '/' + cmp_logo;
    } catch {
      return environment.API_URL + media_url + '/' + cmp_logo;
    }

    return environment.API_URL + media_url + '/' + cmp_logo;
  }

  async generate_amount_based_PDF(
    table_card_1,
    table_id,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    if (this.alert_exist == false) {
      this.alert_exist = true;

      this.newConfirmationAlert({
        text: 'Are You Sure Want To Download The PDF ?',
        confirmCallback: () => {
          this.Confirm_generate_amount_based_PDF(
            table_card_1,
            table_id,
            table_heading,
            table_name,
            font_size
          );
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.newWarningAlert({
            text: 'cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_generate_amount_based_PDF(
    table_card_1,
    table_id,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    const doc = new jsPDF();
    const logoURL = this.set_brand_logo(); // Replace with the correct path to your company logo image
    doc.addImage(logoURL, 'JPEG', 10, 10, 40, 15);
    doc.setTextColor(100, 107, 111);
    const leftFooterContent = '+91 ' + this.localStorage.getItem('cmp_contact');
    const rightFooterContent = this.localStorage.getItem('cmp_website');

    const CurentDate = new Date().toISOString().substring(0, 10);
    const CurrentTime = new Date().toLocaleTimeString('en-US', {
      hour12: true,
    });
    const user_mobile = this.localStorage.getItem('user_name');

    const customFooter = (data: any) => {
      // Left footer
      doc.setFontSize(10);
      doc.text(leftFooterContent, 10, doc.internal.pageSize.height - 10);
      // Right footer
      doc.text(
        rightFooterContent,
        doc.internal.pageSize.width - 50,
        doc.internal.pageSize.height - 10
      );
    };

    // Create an HTML structure for the card content
    // const cardContent = document.querySelector('#card');

    const cardData = document.getElementById(table_card_1);
    const tableData = [document.getElementById(table_id)];

    const cardTableParams = {
      theme: 'plain',
      startY: 38, // Adjust the Y coordinate to make space for the header
      body: cardData,
      styles: {
        fontSize: 8,
        halign: 'left', // Adjust text alignment as needed
        fontStyle: 'bold',
        cellWidth: 60, // Set a fixed column width
        cellSpace: 3,
      },
    };

    // to set table heading
    doc.setFontSize(16);
    doc.setTextColor(0);
    // (doc as any).setFont('bold');
    const captionText = table_heading;
    const textWidth =
      (doc.getStringUnitWidth(captionText) *
        (doc as any).internal.getFontSize()) /
      doc.internal.scaleFactor;
    const xOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(captionText, xOffset, 30);

    const tableParams = {
      // theme: 'plain',
      // startY: 60, // Adjust the Y coordinate to make space for the header
      addPageContent: customFooter,
      // addPageContent1: customHeader,
      fontStyle: 'bold',
      body: tableData,
      styles: {
        fontSize: font_size, // Set the font size for the table content
        halign: 'center', // Right-aligned body text
        fontStyle: 'bold',
        cellWidth: 'warp', // Set a fixed column width
      },

      headStyles: {
        // Customize styles for the table headings
        fillColor: [108, 11, 11], // Background color as RGB (red)
        textColor: [255, 255, 255], // Text color as RGB (white)
        fontSize: font_size,
        halign: 'center',
        cellWidth: 'warp', // Set a fixed column width
        fontStyle: 'bold',
      },
      tableWidth: 190, //'190' 'auto' or 'wrap' to adjust table width automatically or 'wrap' to fit content
      margin: { top: 20, left: 10 },
      // Your table data here
      didParseCell: (data: any) => {
        console.log(data);
        if (data.section === 'body') {
          const cellText = data.cell.text?.toString().trim();

          console.log('Cell Value:', cellText);
          if (cellText.toLowerCase().includes('total')) {
            for (const key in data.row.cells) {
              if (data.row.cells.hasOwnProperty(key)) {
                const cell = data.row.cells[key];
                cell.styles.fontStyle = 'bold';
                cell.styles.textColor = 0;
              }
            }
          }

          // ✅ If cell is a valid number, align it right
          else if (
            /^\d+(\.\d+)?\s*\w*$/.test(cellText.replace(/,/g, '').trim())
          ) {
            data.cell.text = [cellText]; // Keep original text format
            data.cell.styles.halign = 'right'; // Align right for numbers
          }

          if (data.section == 'foot') {
            data.cell.styles.halign = 'right';
          }
        }
      },
    };

    // Add your table content for multiple pages
    // const tableData = [document.getElementById('curr_table')];

    // Function to add the table to the PDF
    const addTableToPDF = () => {
      (doc as any).autoTable({ html: '#' + table_id, ...tableParams });
    };
    const addCardToPDF = (cardTable: HTMLElement | null, params: any) => {
      if (cardTable) {
        (doc as any).autoTable({ html: cardTable, ...params });
      }
    };
    addCardToPDF(cardData, cardTableParams);

    // Loop to add the table content
    for (let i = 0; i < tableData.length; i++) {
      addTableToPDF();

      if (i === tableData.length - 1) {
        // Define your middle footer content
        const middleFooterContent =
          ' This is computer generated Report. No Signature Required.' +
          ' Printed on ' +
          (CurentDate.split('-')[2] +
            '-' +
            CurentDate.split('-')[1] +
            '-' +
            CurentDate.split('-')[0]) +
          ' at ' +
          CurrentTime +
          ' by ' +
          user_mobile +
          '';
        const middleFooterContent1 =
          '                            * End of Report *';
        doc.setFontSize(9);
        doc.text(middleFooterContent, 65, (doc as any).autoTableEndPosY() + 10);
        doc.text(
          middleFooterContent1,
          65,
          (doc as any).autoTableEndPosY() + 17
        );
      }
    }

    // Adding Page Numbers
    const pageCount = (doc as any).internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(
        '' + i,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // Save or display the PDF
    doc.save(table_name + '.pdf');
  }

  async export(
    fileName: string,
    sheets: {
      cardId: string;
      tableId: string;
      sheetName: string;
      cardTitle: string; // ✅ NEW
    }[],
  ) {
    const workbook = new ExcelJS.Workbook();

    const rootStyles = getComputedStyle(document.documentElement);

    const headerBg = this.cssToExcelARGB(
      rootStyles.getPropertyValue('--table_header_back_color').trim(),
    );

    const headerText = this.cssToExcelARGB(
      rootStyles.getPropertyValue('--table_header_text_color').trim(),
    );

    const tableBg = this.cssToExcelARGB(
      rootStyles.getPropertyValue('--table_back_color').trim(),
    );

    for (const sheetInfo of sheets) {
      const worksheet = workbook.addWorksheet(sheetInfo.sheetName);

      const cardEl = document.getElementById(sheetInfo.cardId);
      const tableEl = document.getElementById(sheetInfo.tableId);

      let rowIndex = 1;
      let headerRowNumber = 0;

      /* =========================
       🧠 DETECT TABLE WIDTH
    ========================== */
      let totalCols = 0;

      if (tableEl) {
        const firstRow = tableEl.querySelector('tr');
        if (firstRow) {
          totalCols = firstRow.querySelectorAll('th, td').length;
        }
      }

      if (totalCols === 0) totalCols = 8;

      const lastCol = this.getExcelColumnName(totalCols);

      /* =========================
       🏢 COMPANY NAME
    ========================== */
      const companyName = this.localStorage.getItem('cmp_name') || 'POSTULATE POS';

      const companyRow = worksheet.getRow(rowIndex);
      companyRow.values = [companyName];

      companyRow.font = {
        bold: true,
        size: 16,
        color: { argb: headerBg },
      };

      companyRow.alignment = { horizontal: 'center', vertical: 'middle' };

      worksheet.mergeCells(`A${rowIndex}:${lastCol}${rowIndex}`);

      rowIndex++;

      const sheetTitleRow = worksheet.getRow(rowIndex);
      sheetTitleRow.values = [sheetInfo.sheetName];

      sheetTitleRow.font = {
        bold: true,
        size: 12,
        color: { argb: headerText },
      };

      sheetTitleRow.alignment = { horizontal: 'center' };

      worksheet.mergeCells(`A${rowIndex}:${lastCol}${rowIndex}`);

      rowIndex++;

      /* =========================
       🟦 CARD SECTION
    ========================== */
      if (cardEl) {
        const title = sheetInfo.cardTitle || 'Report';

        const titleRow = worksheet.getRow(rowIndex);
        titleRow.values = [title];

        titleRow.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
        titleRow.alignment = { horizontal: 'center' };
        titleRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: headerBg },
        };

        worksheet.mergeCells(`A${rowIndex}:${lastCol}${rowIndex}`);

        rowIndex++;

        cardEl.querySelectorAll('td').forEach((td) => {
          const text = td.innerText.trim();
          const row = worksheet.getRow(rowIndex);

          if (text.includes(':')) {
            const [label, value] = text.split(':');
            row.values = [`${label.trim()} : ${value?.trim()}`];
          } else {
            row.values = [text];
          }

          row.alignment = { horizontal: 'center' };

          worksheet.mergeCells(`A${rowIndex}:${lastCol}${rowIndex}`);

          rowIndex++;
        });

        rowIndex++;
      }

      /* =========================
       🟩 TABLE SECTION
    ========================== */
      if (tableEl) {
        const rows = tableEl.querySelectorAll('tr');

        rows.forEach((row: any, rIndex: number) => {
          const excelRow = worksheet.getRow(rowIndex);

          const cells = row.querySelectorAll('th, td');

          cells.forEach((c: any, colIndex: number) => {
            const text = c.innerText.trim();
            const headerCell = tableEl.querySelectorAll('tr')[0]?.querySelectorAll('th, td')[colIndex] as HTMLElement;
            const key = headerCell?.innerText?.toLowerCase() || '';
            const parsed = this.detectType(text, key);

            const cell = excelRow.getCell(colIndex + 1);

            // ✅ SET VALUE
            cell.value = parsed.value;

            // 🎯 TYPE FORMATTING
            if (parsed.type === 'amount') {
              // 👉 ONLY amount gets .00
              cell.numFmt = '#,##0.00';
              cell.alignment = { horizontal: 'right' };

            } else if (parsed.type === 'number') {
              // 👉 normal numbers (S.No, Qty)
              cell.numFmt = '0';
              cell.alignment = { horizontal: 'right' };

            } else if (parsed.type === 'date') {
              // cell.numFmt = 'dd-mm-yyyy';
              cell.alignment = { horizontal: 'center' };

            } else {
              cell.alignment = { horizontal: 'left' };
            }

            // Optional: body background
            if (rIndex % 2 === 1 && !row.querySelector('th')) {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: tableBg },
              };
            }
          });

          /* =========================
           🟩 HEADER STYLE
        ========================== */
          if (row.querySelector('th')) {
            headerRowNumber = rowIndex;

            excelRow.font = { bold: true, color: { argb: headerText } };
            excelRow.alignment = { horizontal: 'center', vertical: 'middle' };
            excelRow.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: headerBg },
            };

            excelRow.eachCell((cell) => {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              };
            });
          }

          /* =========================
           🟥 FOOTER STYLE
        ========================== */
          if (rIndex === rows.length - 1) {
            excelRow.font = { bold: true };

            excelRow.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFF2F2F2' },
            };

            excelRow.eachCell((cell, colNumber) => {
              if (colNumber > 1) {
                cell.alignment = { horizontal: 'right' };
              }
            });
          }

          rowIndex++;
        });
      }

      /* =========================
       📏 COLUMN WIDTH
    ========================== */
      for (let i = 1; i <= totalCols; i++) {
        worksheet.getColumn(i).width = 20;
      }

      /* =========================
       🧊 FREEZE HEADER
    ========================== */
      if (headerRowNumber > 0) {
        worksheet.views = [
          {
            state: 'frozen',
            ySplit: headerRowNumber,
          },
        ];

        /* =========================
         🔍 AUTO FILTER
      ========================== */
        worksheet.autoFilter = {
          from: `A${headerRowNumber}`,
          to: `${lastCol}${headerRowNumber}`,
        };
      }
    }

    /* =========================
     💾 DOWNLOAD FILE
    ========================== */
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  private detectType(value: string, key: string = '') {

    const clean = value.replace(/,/g, '').trim();

    // 🔍 CHECK IF AMOUNT COLUMN
    const isAmountField =
      key.includes('amt') ||
      key.includes('amount') ||
      key.includes('total') ||
      key.includes('net');

    // NUMBER
    if (/^\d+(\.\d+)?$/.test(clean)) {
      if (isAmountField) {
        return { type: 'amount', value: Number(clean) };
      }
      return { type: 'number', value: Number(clean) };
    }

    // DATE (dd-mm-yyyy or dd/mm/yyyy)
    if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(value)) {
      const parts = value.split(/[-/]/);
      // ✅ Return formatted string — skip Date object entirely
      return {
        type: 'date',
        value: `${parts[0]}-${parts[1]}-${parts[2]}` // "19-01-2026"
      };
    }

    // ✅ FIXED: DATE (yyyy-mm-dd) — was using new Date(value) which parses as UTC
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const parts = value.split('-');
      // ✅ Reformat to dd-mm-yyyy string
      return {
        type: 'date',
        value: `${parts[2]}-${parts[1]}-${parts[0]}` // "19-01-2026"
      };
    }

    return { type: 'string', value };
  }

  // private detectType(value: string, key: string = '') {

  //   const clean = value.replace(/,/g, '').trim();

  //   // 🔍 CHECK IF AMOUNT COLUMN
  //   const isAmountField =
  //     key.includes('amt') ||
  //     key.includes('amount') ||
  //     key.includes('total') ||
  //     key.includes('net');

  //   // NUMBER
  //   if (/^\d+(\.\d+)?$/.test(clean)) {

  //     if (isAmountField) {
  //       return { type: 'amount', value: Number(clean) }; // ✅ amount
  //     }

  //     return { type: 'number', value: Number(clean) }; // ✅ normal number
  //   }

  //   // DATE (dd-mm-yyyy)
  //   if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(value)) {
  //     const parts = value.split(/[-/]/);

  //     return {
  //       type: 'date',
  //       value: new Date(
  //         Number(parts[2]),
  //         Number(parts[1]) - 1,
  //         Number(parts[0])
  //       )
  //     };
  //   }

  //   // DATE (yyyy-mm-dd)
  //   if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
  //     return {
  //       type: 'date',
  //       value: new Date(value)
  //     };
  //   }

  //   return { type: 'string', value };
  // }


  private cssToExcelARGB(cssColor: string): string {
    // If already hex (#305496)
    if (cssColor.startsWith('#')) {
      return 'FF' + cssColor.replace('#', '').toUpperCase();
    }

    // If rgb(48, 84, 150)
    const rgb = cssColor.match(/\d+/g);

    if (!rgb) return 'FFFFFFFF';

    return (
      'FF' +
      rgb
        .map((x) => {
          const hex = parseInt(x).toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        })
        .join('')
        .toUpperCase()
    );
  }

  private getExcelColumnName(colIndex: number): string {
    let dividend = colIndex;
    let columnName = '';

    while (dividend > 0) {
      let modulo = (dividend - 1) % 26;
      columnName = String.fromCharCode(65 + modulo) + columnName;
      dividend = Math.floor((dividend - modulo) / 26);
    }

    return columnName;
  }

  compressImageSmart(file: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const canvas = document.createElement('canvas');

          let maxWidth = 1280;

          if (file.size > 3 * 1024 * 1024) {
            maxWidth = 800;   // big images → more resize
          } else if (file.size > 1 * 1024 * 1024) {
            maxWidth = 1000;
          }

          const targetWidth = img.width > maxWidth ? maxWidth : img.width;
          const scaleFactor = targetWidth / img.width;

          canvas.width = targetWidth;
          canvas.height = img.height * scaleFactor;

          const ctx = canvas.getContext('2d');
          ctx!.drawImage(img, 0, 0, canvas.width, canvas.height);

          let quality = 0.8;
          const minQuality = 0.4;

          const compressLoop = (): Promise<Blob> => {
            return new Promise((res, rej) => {
              canvas.toBlob((blob) => {
                if (!blob) return rej('Compression failed');

                if (blob.size <= 1 * 1024 * 1024) {
                  return res(blob);
                }

                quality -= 0.05;

                if (quality < minQuality) {
                  return res(blob); // stop to avoid too much blur
                }

                res(compressLoop());
              }, 'image/jpeg', quality);
            });
          };

          try {
            const finalBlob = await compressLoop();
            resolve(finalBlob);
          } catch (err) {
            reject(err);
          }
        };

        img.onerror = () => reject('Invalid image file');
      };

      reader.onerror = () => reject('File read error');
      reader.readAsDataURL(file);
    });
  }
  saveDeviceToken(token: string, userId: any, deviceType: string) {
    return this.call_http_post({
      url: environment.API_URL + 'notifications/save-device-token',
      data: {
        token: token,
        user_id: userId,
        device_type: deviceType
      },
      successCb: (res: any) => {
        console.log('Token saved successfully');
      },
      errorCb: (err: any) => {
        console.log('Error saving token', err);
      }
    });
  }

  showToast(options: {
    action?: 'success' | 'error' | 'warning' | 'info' | 'update' | 'delete';
    text: string;
    showOk?: boolean;
    duration?: number;
    callback?: () => void;
  }) {
    const { action = 'success', text, showOk = false, callback } = options;
    // const { action = 'success', text, showOk = false, duration = 5000, callback } = options;

    let bg = '';
    let icon = '';

    switch (action) {
      case 'success':
        bg = 'linear-gradient(135deg,#00b09b,#96c93d)';
        icon = 'checkmark-circle';
        break;

      case 'error':
        bg = 'linear-gradient(135deg,#ff416c,#ff4b2b)';
        icon = 'close-circle';
        break;

      case 'warning':
        bg = 'linear-gradient(135deg,#f7971e,#ffd200)';
        icon = 'warning';
        break;

      case 'info':
        bg = 'linear-gradient(135deg,#2193b0,#6dd5ed)';
        icon = 'information-circle';
        break;

      case 'update':
        bg = 'linear-gradient(135deg,#2193b0,#6dd5ed)';
        icon = 'information-circle';
        break;

      case 'delete':
        bg = 'linear-gradient(135deg,#ff4b2b,#ff416c)';
        icon = 'trash';
        break;
    }

    // if (callback && !showOk) {
    //   callback();
    // }

    this.toastData = {
      action: action,
      message: text,
      bgGradient: bg,
      icon: icon,
      showOk: showOk,
      // duration,
      callback: callback,
    };
  }

  setCSSVariable(variable: string, value: string): void {
    // Access the root element (:root) and set the CSS variable
    document.documentElement.style.setProperty(variable, value);
  }

  set_website_colour(data: any) {
    this.localStorage.setItem('bg_color', data.bg_color);
    this.localStorage.setItem('menu_bg_color', data.menu_bg_color);
    this.localStorage.setItem('menu_internal_color', data.menu_internal_color);
    this.localStorage.setItem('nav_bg_color', data.nav_bg_color);
    this.localStorage.setItem('menu_txt_color', data.menu_txt_color);
    this.localStorage.setItem('nav_txt_color', data.nav_txt_color);
    this.localStorage.setItem('menu_hover_color', data.menu_hover_color);
    this.localStorage.setItem('btn_bg_color', data.btn_bg_color);
    this.localStorage.setItem('btn_txt_color', data.btn_txt_color);
    this.localStorage.setItem('btn_hover_color', data.btn_hover_color);
    this.localStorage.setItem('cancel_btn_bg_color', data.cancel_btn_bg_color);
    this.localStorage.setItem(
      'cancel_btn_txt_color',
      data.cancel_btn_txt_color,
    );
    this.localStorage.setItem(
      'cancel_btn_hover_color',
      data.cancel_btn_hover_color,
    );
    this.localStorage.setItem('tab_head_bg_color', data.tab_head_bg_color);
    this.localStorage.setItem('tab_head_txt_color', data.tab_head_txt_color);
  }

  get_website_colour() {
    var bg_color = this.localStorage.getItem('bg_color');
    var menu_bg_color = this.localStorage.getItem('menu_bg_color');
    var menu_internal_color = this.localStorage.getItem('menu_internal_color');
    var nav_bg_color = this.localStorage.getItem('nav_bg_color');
    var menu_txt_color = this.localStorage.getItem('menu_txt_color');
    var nav_txt_color = this.localStorage.getItem('nav_txt_color');
    var menu_hover_color = this.localStorage.getItem('menu_hover_color');
    var btn_bg_color = this.localStorage.getItem('btn_bg_color');
    var btn_txt_color = this.localStorage.getItem('btn_txt_color');
    var btn_hover_color = this.localStorage.getItem('btn_hover_color');
    var cancel_btn_bg_color = this.localStorage.getItem('cancel_btn_bg_color');
    var cancel_btn_txt_color = this.localStorage.getItem(
      'cancel_btn_txt_color',
    );
    var cancel_btn_hover_color = this.localStorage.getItem(
      'cancel_btn_hover_color',
    );
    var tab_head_bg_color = this.localStorage.getItem('tab_head_bg_color');
    var tab_head_txt_color = this.localStorage.getItem('tab_head_txt_color');

    this.setCSSVariable('--primary_body_color', bg_color);
    this.setCSSVariable('--nav_bar_primary_color', menu_bg_color);
    this.setCSSVariable('--nav_bar_secondary_color', menu_internal_color);
    this.setCSSVariable('--nav_bar_header_bg_color', nav_bg_color);
    this.setCSSVariable('--side_menu_text_color', menu_txt_color);
    this.setCSSVariable('--menu_bar_text_color', nav_txt_color);
    this.setCSSVariable('--nav_bar_hover_color', menu_hover_color);
    this.setCSSVariable('--solo_button_back_colour', btn_bg_color);
    this.setCSSVariable('--solo_button_text_colour', btn_txt_color);
    this.setCSSVariable('--solo_button_hover_colour', btn_hover_color);
    this.setCSSVariable('--cancel_button_back_colour', cancel_btn_bg_color);
    this.setCSSVariable('--cancel_button_text_colour', cancel_btn_txt_color);
    this.setCSSVariable('--cancel_button_hover_colour', cancel_btn_hover_color);
    this.setCSSVariable('--table_header_back_color', tab_head_bg_color);
    this.setCSSVariable('--table_header_text_color', tab_head_txt_color);
  }
}
